// extracted by mini-css-extract-plugin
export default {"link":"NavAuth_link__qM73S"};